/* House of Tamyra — cart drawer.
   Re-renders the drawer from the Section Rendering API after every cart change,
   so all prices/discounts are computed by Liquid, not duplicated in JS. */
(function () {
  'use strict';
  var SECTION = 'tamyra-cart-drawer';
  var root, panel, lastFocus;

  function q(sel, el) { return (el || document).querySelector(sel); }
  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTION, sections_url: window.location.pathname }, body))
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data && (data.description || data.message) || 'Cart error');
        return data;
      });
    });
  }

  function render(html) {
    if (!root || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = q('[data-cart-body]', doc);
    var current = q('[data-cart-body]', root);
    if (fresh && current) current.replaceWith(fresh);
    var count = q('[data-cart-body] .t-cart__title', root);
    var m = count && /\((\d+)\)/.exec(count.textContent);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (!m) return;
      el.textContent = m[1];
      el.hidden = m[1] === '0';
    });
    document.dispatchEvent(new CustomEvent('tamyra:cart:updated'));
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { render(d[SECTION]); });
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.classList.add('is-open');
    document.documentElement.classList.add('t-cart-open');
    root.setAttribute('aria-hidden', 'false');
    setTimeout(function () { var c = q('[data-cart-close]', panel); if (c) c.focus(); }, 60);
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('t-cart-open');
    root.setAttribute('aria-hidden', 'true');
    setTimeout(function () { root.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function busy(on) { if (root) root.classList.toggle('is-busy', !!on); }

  function add(items) {
    busy(true);
    return json('/cart/add.js', { items: items }).then(function (d) {
      render(d.sections && d.sections[SECTION]);
      if (!d.sections) return refresh();
    }).then(function () { busy(false); open(); })
      .catch(function (e) { busy(false); throw e; });
  }
  function change(line, quantity) {
    busy(true);
    return json('/cart/change.js', { line: line, quantity: quantity }).then(function (d) {
      render(d.sections && d.sections[SECTION]);
      busy(false);
    }).catch(function () { busy(false); return refresh(); });
  }

  function lineOf(el) { var li = el.closest('[data-line]'); return li ? Number(li.dataset.line) : 0; }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open], [data-cart-close], [data-cart-qty], [data-cart-remove], [data-cart-add]');
    if (!t || !root) return;
    if (t.hasAttribute('data-cart-open')) { e.preventDefault(); refresh().then(open, open); return; }
    if (t.hasAttribute('data-cart-close')) { close(); return; }
    if (t.hasAttribute('data-cart-remove')) { change(lineOf(t), 0); return; }
    if (t.hasAttribute('data-cart-add')) {
      t.disabled = true;
      add([{ id: Number(t.dataset.cartAdd), quantity: 1 }]).catch(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-cart-qty')) {
      var input = q('[data-cart-qty-input]', t.parentElement);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(t.dataset.cartQty));
      change(lineOf(t), next);
    }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cart-qty-input]')) return;
    change(lineOf(e.target), Math.max(0, parseInt(e.target.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) close(); });

  function init() {
    root = q('[data-t-cart]');
    panel = root && q('.t-cart__panel', root);
    if (!root) return;
    window.TamyraCart = { open: open, close: close, refresh: refresh, add: add, change: change };
    document.dispatchEvent(new CustomEvent('tamyra:cart:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
